// angular
// .module("HeroPRO")
// .controller("PersonalInfoController", personalInfoController);

import _ from 'lodash';
import './personalInfo.scss';

/* @ngInject */
export default function personalInfoController(AdvancedRegistrationFactory, UserData, AccountsFactory, raSpinnerService) {
  const vm = this;

  vm.globalError = 'Please complete all required fields before proceeding.';
  vm.ownerFirstName = null;
  vm.ownerLastName = null;
  vm.ownerDOB = null;
  vm.ownerDOBMonth = null;
  vm.ownerDOBDay = null;
  vm.ownerDOBYear = null;
  vm.ownerCityName = null;
  vm.ownerPhone = null;
  vm.ownerSSN = null;
  vm.ownerAddress1 = null;
  vm.ownerState = null;
  vm.ownerZipcode = null;
  vm.isStateOpen = false;
  vm.states = null;
  vm.ownerEmail = null;
  vm.loading = false;

  let savedPersonalInfo = null;

  init();

  /*= =======================================
  =            Public Functions            =
  ======================================== */
  vm.validateDob = function () {
    if (!isValidDate(vm.ownerDOB)) {
      vm.ownerInfoForm.ownerDob.$setValidity('invalidDate', false);
    } else {
      vm.ownerInfoForm.ownerDob.$setValidity('invalidDate', true);
      processDOB();

      if (!isDate18orMoreYearsOld(vm.ownerDOBDay, vm.ownerDOBMonth, vm.ownerDOBYear)) {
        vm.ownerInfoForm.ownerDob.$setValidity('underAge', false);
      } else {
        vm.ownerInfoForm.ownerDob.$setValidity('underAge', true);
      }
    }
  };

  vm.numbersOnly = function (evt) {
    const isNumber = numbersOnly(evt);

    if (!isNumber) {
      evt.preventDefault();
    }
  };

  vm.submitForm = function (isValid) {
    if (isValid) {
      vm.loading = true;
      processDOB();
      savePersonalInfo();

      const params = {
        IdVerifyInfo: {
          FirstName: vm.ownerFirstName,
          LastName: vm.ownerLastName,
          Address: vm.ownerAddress1,
          City: vm.ownerCityName,
          State: vm.ownerState,
          Zip: vm.ownerZipcode,
          SsnLast4: vm.ownerSSN,
          DobDay: vm.ownerDOBDay,
          DobMonth: vm.ownerDOBMonth,
          DobYear: vm.ownerDOBYear,
        },
        PersonIdentityId: null,
        Email: vm.ownerEmail,
        MobilePhone: vm.ownerPhone,
      };

      AdvancedRegistrationFactory.attempAutoIDV(params).then((response) => {

        const res = response.data.Data;

        AdvancedRegistrationFactory.setPersonIdentityId(res.PersonIdentityId);

        if (res.Status === 4) {
          // FAIL, User has been banned
          vm.closeModal();
          AdvancedRegistrationFactory.setVisiblePages(['banned']);
        }
        else if (res.Status === 5 || (res.Status === 3 && res.ErrorMessage === 'Too many attempts within 24 hours')) {
          // ID Found but no questions returned. Show upload screen
          // OR:
          // FAIL, TOO MANY ATTEMPTS
          vm.closeModal();
          AdvancedRegistrationFactory.setVisiblePages(['uploadId']);
        } else if (res.Status === 6) {
          // FAIL, FOUND
          vm.closeModal();
          AdvancedRegistrationFactory.setIdNumber(res.Questions.ResponseInfo.IdNumber);
          AdvancedRegistrationFactory.setQuestions(res.Questions.ResponseInfo.Questions);
          AdvancedRegistrationFactory.setVisiblePages(['questions']);
        } else if (res.Status === 1) {
          // vm.closeModal();
          // return;
          // PASS
          // complete Adv Reg
          // TODO: Check into what the value of getIdNumber was here before optimizations were turned off.
          const idNumber = AdvancedRegistrationFactory.getIdNumber() || 0;

          AdvancedRegistrationFactory.completeAdvancedRegistration({
            PersonIdentityId: AdvancedRegistrationFactory.getPersonIdentityId(),
            ContractorUserId: AdvancedRegistrationFactory.getContractorUserId(),
            IdNumber: idNumber,
            isAutoIDV: true,
          });

          const params = {
            // Hardcoding needs to be changed to a dynamic value once
            // the API is returning the ActionItemTypeConfigurationId
            ActionItemTypeConfigurationId: 32,
          };

          AdvancedRegistrationFactory.completeAdvancedRegActionItem(params).then(() => {
            vm.closeModal();
            AdvancedRegistrationFactory.setVisiblePages(['success']);
          });
        } else if (res.Status === 2) {
          // FAIL, NOT FOUND
          vm.closeModal();
          AdvancedRegistrationFactory.setVisiblePages(['tryAgain']);
        }
      });
    }
  };
  /* -----  End of Public Functions  ------*/


  /*= =======================================
  =            Private Functions            =
  ======================================== */
  function init() {
    vm.loading = false;
    AdvancedRegistrationFactory.getStates().then((response) => {
      vm.states = response;
    });

    UserData.getUserData().then((response) => {
      vm.ownerEmail = response.UserName;
      vm.ownerFirstName = response.FirstName;
      vm.ownerLastName = response.LastName;
      AdvancedRegistrationFactory.setContractorUserId(response.ContractorUserId);
      AccountsFactory.getContractorUser(response.ContractorUserId).then((responseUser) => {
        vm.ownerPhone = responseUser.data.Data.Phone;
      });
    });

    savedPersonalInfo = AdvancedRegistrationFactory.getPersonalInfo();
    if (!_.isEmpty(savedPersonalInfo)) {
      loadPersonalInfo();
    }
  }

  function loadPersonalInfo() {
    vm.ownerFirstName = savedPersonalInfo.ownerFirstName;
    vm.ownerLastName = savedPersonalInfo.ownerLastName;
    vm.ownerDOB = savedPersonalInfo.ownerDOB;
    vm.ownerDOBMonth = savedPersonalInfo.ownerDOBMonth;
    vm.ownerDOBDay = savedPersonalInfo.ownerDOBDay;
    vm.ownerDOBYear = savedPersonalInfo.ownerDOBYear;
    vm.ownerCityName = savedPersonalInfo.ownerCityName;
    vm.ownerPhone = savedPersonalInfo.ownerPhone;
    vm.ownerSSN = savedPersonalInfo.ownerSSN;
    vm.ownerAddress1 = savedPersonalInfo.ownerAddress1;
    vm.ownerState = savedPersonalInfo.ownerState;
    vm.ownerZipcode = savedPersonalInfo.ownerZipcode;
  }

  function savePersonalInfo() {
    const personalInfo = {};

    personalInfo.ownerFirstName = vm.ownerFirstName;
    personalInfo.ownerLastName = vm.ownerLastName;
    personalInfo.ownerDOB = vm.ownerDOB;
    personalInfo.ownerDOBMonth = vm.ownerDOBMonth;
    personalInfo.ownerDOBDay = vm.ownerDOBDay;
    personalInfo.ownerDOBYear = vm.ownerDOBYear;
    personalInfo.ownerCityName = vm.ownerCityName;
    personalInfo.ownerPhone = vm.ownerPhone;
    personalInfo.ownerSSN = vm.ownerSSN;
    personalInfo.ownerAddress1 = vm.ownerAddress1;
    personalInfo.ownerState = vm.ownerState;
    personalInfo.ownerZipcode = vm.ownerZipcode;

    AdvancedRegistrationFactory.setPersonalInfo(personalInfo);
  }

  function processDOB() {
    vm.ownerDOBMonth = vm.ownerDOB.substr(0, 2);
    vm.ownerDOBDay = vm.ownerDOB.substr(2, 2);
    vm.ownerDOBYear = vm.ownerDOB.substr(4, 4);
  }

  function numbersOnly(e) {
    const numbers = [8, 9, 46];

    for (let i = 48; i <= 57; i++) {
      numbers.push(i);
    }

    const nonNumber = _.find(numbers, n => n === e.which);

    return !angular.isUndefined(nonNumber);
  }


  vm.closeModal = function () {
    vm.loading = false;
    raSpinnerService._unregister('personalInfoSpinner');
  };


  function isDate18orMoreYearsOld(day, month, year) {
    const mydate = new Date();
    mydate.setFullYear(year, month - 1, day);
    const age = 18;
    const currdate = new Date();
    currdate.setFullYear(currdate.getFullYear() - age);

    const more18Years = currdate >= mydate;
    return more18Years;
  }

  function isValidDate(dateString, checkToday) {
    // First check for the pattern
    if (!/^(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])(19|20)\d\d$/.test(dateString)) {
      return false;
    }

    if (angular.isUndefined(checkToday)) {
      checkToday = false;
    }

    // Parse the date parts to integers
    const day = parseInt(dateString.substring(2, 4), 10);
    const month = parseInt(dateString.substring(0, 2), 10);
    const year = parseInt(dateString.substring(4), 10);

    // Set date values
    const date = new Date(year, month - 1, day);
    const currentDate = Date.now();
    const minDate = new Date(1920, 0, 1);
    const msPerDay = 86400000;

    const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Adjust for leap years
    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
      monthLength[1] = 29;
    }

    if (date.getTime() > currentDate && !checkToday) { // Check if date is greater than today
      return false;
    }

    if (date.getTime() < (currentDate - msPerDay) && checkToday) {
      return false;
    }

    if (date < minDate) { // Check if date is less than the min date
      return false;
    }

    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1]; // Month is 0 based
  }
  /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/notificationCenter/modal/templates/advancedRegistration/personalInfo/personalInfoController.js